export class FaseProcesso{
    id = 0;
    descricao = '';
    situacao: Boolean;
}